import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import FreightForwarding from './pages/FreightForwarding';
import CustomsClearance from './pages/CustomsClearance';
import AirFreight from './pages/AirFreight';
import OceanFreight from './pages/OceanFreight';
import ImportSolutions from './pages/ImportSolutions';
import ExportSolutions from './pages/ExportSolutions';
import SupplyChain from './pages/SupplyChain';
import TradeRoutes from './pages/TradeRoutes';
import Industries from './pages/Industries';
import FAQ from './pages/FAQ';
import Contact from './pages/Contact';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/freight-forwarding" element={<FreightForwarding />} />
          <Route path="/services/customs-clearance" element={<CustomsClearance />} />
          <Route path="/services/air-freight" element={<AirFreight />} />
          <Route path="/services/ocean-freight" element={<OceanFreight />} />
          <Route path="/services/import-solutions" element={<ImportSolutions />} />
          <Route path="/services/export-solutions" element={<ExportSolutions />} />
          <Route path="/services/supply-chain" element={<SupplyChain />} />
          <Route path="/trade-routes" element={<TradeRoutes />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <WhatsAppFloat />
      </BrowserRouter>
    </div>
  );
}

export default App;